module.exports = __webpack_public_path__ + "static/home_spoleczna_odp-92615f8b3c864c7b2822404f356f9186.jpg";